import React from 'react';
import { Card } from './ui/card';

const Hosts = () => {
  const hosts = [
    {
      id: 1,
      name: "Nicholas Buamah",
      role: "Host & Creator",
      instagram: "https://www.instagram.com/nicholasbuamah/",
      image: "/nicholas.png"
    },
    {
      id: 2,
      name: "Janae Madison",
      role: "Host & Creator",
      instagram: "https://www.instagram.com/iamjanaemadison/",
      image: "/janae.png"
    }
  ];

  return (
    <section className="hosts-section" id="hosts">
      <div className="container">
        <h2 className="section-title-center">Hosts</h2>
        <p className="section-subtitle-center">
          Meet the dynamic duo bringing The Nick and JJ Show to life!
        </p>
        
        <div className="hosts-grid">
          {hosts.map((host) => (
            <Card key={host.id} className="host-card">
              <div className="host-image-wrapper">
                <img 
                  src={host.image} 
                  alt={host.name}
                  className="host-image"
                />
              </div>
              <div className="host-content">
                <h3 className="host-name">{host.name}</h3>
                <a 
                  href={host.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="host-role-link"
                >
                  {host.role}
                </a>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hosts;